interface UseDocumentListItemProps {
  documentUuid: string;
  url?: string;
  onDownload?: (documentUuid: string) => void;
  onRemove?: (documentUuid: string) => void;
}

interface UseDocumentListItemReturnData {
  canDownload: boolean;
  handleDownload: () => void;
  handleRemove: () => void;
}

const openInNewTab = (url: string): void => {
  window.open(url, "_blank")?.focus();
};

export const useDocumentListItem = ({
  documentUuid,
  url,
  onDownload,
  onRemove,
}: UseDocumentListItemProps): UseDocumentListItemReturnData => {
  // Download is available when the caller supplies a handler or a direct URL to fall back to.
  const canDownload = Boolean(onDownload || url);

  const handleDownload = (): void => {
    if (onDownload) {
      onDownload(documentUuid);
    } else if (url) {
      openInNewTab(url);
    }
  };

  const handleRemove = (): void => {
    onRemove?.(documentUuid);
  };

  return {
    canDownload,
    handleDownload,
    handleRemove,
  };
};
